import ContainerValidation from './Components/ContainerValidation';
import HeaderValidation from './Components/HeaderValidation';
import BodyValidation from './Components/BodyValidation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import routes from '../../../../Routes/routes';
import {IconUnderReviewIdentity} from '../../../../components/buttons/IconButtons';
import {useSelector} from "react-redux";
import useForbiddenValidation from "./Functionality/useForbiddenValidation";
import {getUrlParameters} from "./Model/Model";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const CurrentlyUnderReview = () => {
    const { id, guardFlowId } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { getInvitationById } = useSelector((state) => state.InvitationSlice);

    useForbiddenValidation({getInvitationById})

    return (
        <ContainerValidation>
            <HeaderValidation url={getUrlParameters({url: routes.invitationDetails.registrationProcess, id, guardFlowId })} />

            <BodyValidation
                showBtnNext={false}
                showBtnPrev={true}
                clickPrev={() => {
                    navigate(getUrlParameters({url: routes.invitationDetails.registrationProcess, id, guardFlowId}))
                }}
            >
                <>
                    <div className="row">
                        <div className="col-12 d-flex flex-column justify-content-center align-items-center">
                            { guardFlowId ?
                                <>
                                    <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("visitor_information_is_currently_under_review")}</p>
                                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("we_will_notify_you_once_the_review_is_complete")}</p>
                                </>
                                :
                                <>
                                    <p className="fs-24-to-18 ibl-font-w-600 font-color-general-950 text-center">{t("your_information_is_currently_under_review")}</p>
                                    <p className="fs-20-to-14 ibl-font-w-400 font-color-general-950 text-center">{t("review_completion_notification")}</p>
                                </>
                            }
                        </div>
                    </div>

                    <div className="d-flex justify-content-center align-items-center">
                        <div className="icon-identity-validation-container">
                            <IconUnderReviewIdentity className="w-100 h-100" />
                        </div>
                    </div>
                </>
            </BodyValidation>
        </ContainerValidation>
    )

}

export default CurrentlyUnderReview
